import Form from '@admin/components/form'
import StrategyToken from './strategy'
import PropTypes from 'prop-types'
import React from 'react'

class Cancel extends React.PureComponent {

  static propTypes = {
    plans: PropTypes.object,
    subscription: PropTypes.object,
    onBack: PropTypes.func,
    onNext: PropTypes.func
  }

  formRef = React.createRef()

  state = {
    config: {}
  }

  _handleBack = this._handleBack.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const next_plan_type = this.props.subscription?.next_period?.plan?.title?.toLowerCase().includes('pro') ? 'pro' : 'essentials'
    return {
      ref: this.formRef,
      showHeader: false,
      buttons: [
        { label: 't(Previous)', color: 'blue', basic: true, handler: this._handleBack },
        { label: 't(Finish)', color: 'blue', handler: this._handleSubmit }
      ],
      onChange: this._handleChange,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { 
              instructions: 't(Before you go, we\'d love to see if there\'s a better way forward. Whether you\'re looking for a break, need something more flexible, or just want to scale back, we have options. Let\'s find what works best for you)',
              name: 'strategy', 
              type: 'radiogroup',
              options: [
                'pause',
                ...next_plan_type === 'pro' ? ['downgrade'] : [],
                'cancel'
              ],
              defaultValue: 'pause',
              format: StrategyToken
            }
          ]
        }
      ]
    }
  }

  _handleBack() {
    this.props.onBack()
  }

  _handleChange(config) {
    this.setState({ config })
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

  _handleSuccess(cancelllation) {
    this.props.onNext(cancelllation)
  }

}

export default Cancel
